var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 49,
    viewBox: "0 0 46 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4375 22.125L21.5 0.75L34.5625 22.125H8.4375ZM34.5625 48.25C31.5938 48.25 29.0703 47.2109 26.9922 45.1328C24.9141 43.0547 23.875 40.5312 23.875 37.5625C23.875 34.5938 24.9141 32.0703 26.9922 29.9922C29.0703 27.9141 31.5938 26.875 34.5625 26.875C37.5312 26.875 40.0547 27.9141 42.1328 29.9922C44.2109 32.0703 45.25 34.5938 45.25 37.5625C45.25 40.5312 44.2109 43.0547 42.1328 45.1328C40.0547 47.2109 37.5312 48.25 34.5625 48.25ZM0.125 47.0625V28.0625H19.125V47.0625H0.125ZM34.5625 43.5C36.225 43.5 37.6302 42.926 38.7781 41.7781C39.926 40.6302 40.5 39.225 40.5 37.5625C40.5 35.9 39.926 34.4948 38.7781 33.3469C37.6302 32.199 36.225 31.625 34.5625 31.625C32.9 31.625 31.4948 32.199 30.3469 33.3469C29.199 34.4948 28.625 35.9 28.625 37.5625C28.625 39.225 29.199 40.6302 30.3469 41.7781C31.4948 42.926 32.9 43.5 34.5625 43.5ZM4.875 42.3125H14.375V32.8125H4.875V42.3125ZM16.8687 17.375H26.1313L21.5 9.89375L16.8687 17.375Z",
    fill: "#181E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2);
export default __webpack_public_path__ + "static/media/card2.eabd4b78d46ee0161b59d23f40aa13cc.svg";
export { ForwardRef as ReactComponent };